import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { get_order } from '../../store/reducers/orderReducer';

const Order = () => {
    const { orderId } = useParams();
    const dispatch = useDispatch();
    const { myOrder, loading, error } = useSelector((state) => state.order);
    const { userInfo } = useSelector((state) => state.auth);

    useEffect(() => {
        console.log("Fetching order with ID:", orderId);
        dispatch(get_order(orderId));
    }, [dispatch, orderId]);
    
    useEffect(() => {
        console.log("Fetched order details:", myOrder);
    }, [myOrder]);

    if (loading) return <p className="text-center text-slate-600">Loading order details...</p>;
    if (error) return <p className="text-center text-red-600">{error}</p>;
    if (!myOrder || !myOrder._id) return <p className="text-center text-slate-600">Order not found.</p>;

    return (
        <div className="bg-white p-5 rounded-md">
            <h2 className="text-slate-600 font-semibold">
                #{myOrder._id}, <span className="pl-1">{new Date(myOrder.date).toLocaleString()}</span>
            </h2>

            <div className="grid grid-cols-2 gap-3">
                <div className="flex flex-col gap-1">
                    <h2 className="text-slate-600 font-semibold">
                        Deliver to: {myOrder.shippingInfo?.name}
                    </h2>
                    <p>
                        <span className="bg-blue-100 text-blue-800 text-xs font-medium mr-2 px-2.5 py-0.5 rounded">
                            Home
                        </span>
                        <span className="text-slate-600 text-sm">
                            {myOrder.shippingInfo?.address}, {myOrder.shippingInfo?.province},
                            {myOrder.shippingInfo?.city}, {myOrder.shippingInfo?.area}
                        </span>
                    </p>
                    <p className="text-slate-600 text-sm font-semibold">
                        Phone: {myOrder.shippingInfo?.phone}
                    </p>
                    <p className="text-slate-600 text-sm font-semibold">
                        Email: {userInfo.email}
                    </p>
                </div>

                <div className="text-slate-600">
                    <h2>Price: Kes{myOrder.price.toFixed(2)} (includes shipping fee)</h2>
                    <p>Payment Status: <span className={`py-[1px] text-xs px-3 ${myOrder.payment_status === 'paid' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'} rounded-md`}>{myOrder.payment_status === 'paid' ? 'Paid ✅' : 'Unpaid ❌'}</span></p>
                    <p>Order Status: <span className={`py-[1px] text-xs px-3 ${myOrder.delivery_status === 'delivered' ? 'bg-indigo-100 text-indigo-800' : 'bg-red-100 text-red-800'} rounded-md`}>{myOrder.delivery_status}</span></p>
                    <p>Mpesa Receipt Number: {myOrder.mpesaReceiptNumber}</p>
                    <p>Mpesa Checkout Request ID: {myOrder.mpesaCheckoutRequestId}</p>
                    <p>Last Payment Check: {new Date(myOrder.lastPaymentCheck).toLocaleString()}</p>
                </div>
            </div>

            <div className="mt-3">
                <h2 className="text-slate-600 text-lg pb-2">Products</h2>
                <div className="flex gap-5 flex-col">
                    {myOrder.products?.map((product, index) => (
                        <div key={index} className="flex gap-5 justify-start items-center text-slate-600">
                            <div className="flex gap-2">
                                <img className="w-[55px] h-[55px]" src={product.images[0]} alt={product.name} />
                                <div className="flex text-sm flex-col justify-start items-start">
                                    <Link to={`/product/${product._id}`} className="text-blue-500">
                                        {product.name}
                                    </Link>
                                    <p><span>Brand: {product.brand}</span><span className="ml-2">Quantity: {product.quantity}</span></p>
                                </div>
                            </div>
                            <div className="pl-4">
                                <h2 className="text-md text-orange-500">Kes{(product.price - (product.price * product.discount / 100)).toFixed(2)}</h2>
                                <p className="line-through text-gray-400">Kes{product.price.toFixed(2)}</p>
                                <p className="text-red-500">-{product.discount}%</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Order;
